import React from 'react';

import CliveSketchAvatarBigImage from './clive-sketch-avatar-big.svg';
import CliveShadowImage from './CliveShadow.svg';

import cn from '~/utils/cn';

interface CliveSketchAvatarBigProps {
  className?: string;
}

const CliveSketchAvatarBig: React.FC<CliveSketchAvatarBigProps> = ({ className }) => (
  <div className={cn('flex flex-col items-center justify-center', className)}>
    <img src={CliveSketchAvatarBigImage} alt="Clive Sketch Avatar" className="mb-40 w-full object-cover" />
    <img src={CliveShadowImage} alt="Clive Sketch Shadow" className="mt-80 w-full object-cover px-80" />
  </div>
);

export default CliveSketchAvatarBig;
